import Phaser from 'phaser'

import BunnyJumpScene from './scenes/BunnyJump'
import GameOverScene from './scenes/GameOverScene'
import StartScene from './scenes/StartScene'
import WinScene from './scenes/WinScene'

const config = {
	type: Phaser.AUTO,
	width: 480,
	height: 640,
	physics: {
		default: 'arcade',
		arcade: {
			gravity: { y: 200 }
		}
	},
	scene: [StartScene, BunnyJumpScene, GameOverScene, WinScene]
}

export default new Phaser.Game(config)
